import { PsvMonitoringTargetKind } from "@api/shared-runtime/psv-monitoring";
import { MONITORING_COPY } from "../monitoring-constants";
import type { ProviderMonitoringStatus } from "../monitoring-types";

type CoveredBy = ProviderMonitoringStatus["coveredBy"];

/** Rules that target this provider directly, which "Stop" removes them from. */
export function directRules(coveredBy: CoveredBy): CoveredBy {
  return coveredBy.filter((rule) =>
    rule.matchedBy.some(
      (match) => match.kind === PsvMonitoringTargetKind.Provider,
    ),
  );
}

/** Pools that cover the provider; unnamed when the reader cannot see them. */
export function poolNames(coveredBy: CoveredBy): string[] {
  const names = coveredBy.flatMap((rule) =>
    rule.matchedBy.flatMap((match) => {
      if (match.kind !== PsvMonitoringTargetKind.Pool) {
        return [];
      }
      return [match.pool?.name ?? MONITORING_COPY.unnamedPool];
    }),
  );
  return [...new Set(names)];
}

export function coveredByLabels(coveredBy: CoveredBy): string[] {
  return coveredBy.flatMap((rule) =>
    rule.matchedBy.map((match) => {
      if (match.kind === PsvMonitoringTargetKind.Provider) {
        return `${rule.name} · direct`;
      }
      return `${rule.name} · ${match.pool?.name ?? MONITORING_COPY.unnamedPool}`;
    }),
  );
}

export function joinNames(names: string[]): string {
  return names.join(", ");
}
